import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData, getDaysBetweenMonths } from "../../../../Utilitie";
import * as echarts from "echarts";

const AvgMWPWILEGraph = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
}) => {
  const mon = new Date().toLocaleString("en-US", { month: "short" });

  const date = new Date().getDate() - 1;

  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};
  useEffect(() => {
    if (selectedMonths.length === 0 || selectedSections.length === 0) return;

    const chartDom = document.getElementById("pwiAvgChart4");
    let myChart = echarts.init(chartDom);

    ////////////////////////////////////////

    const prevLTotalTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b = getDaysBetweenMonths(
            selectedFy.replace(/\d+/g, (y) => +y - 1).slice(0, 4),
            month.slice(0, 3).toUpperCase(),
            month.slice(0, 3).toUpperCase(),
          );
          const d = getSectionData(m, s);
          return (
            acc + Number(d[`${selectedRT.toLowerCase()}_to_loaded`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    const currLTotalTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b =
            Number(selectedFy.slice(0, 4)) === new Date().getFullYear() &&
            month.slice(0, 3) === mon
              ? date
              : getDaysBetweenMonths(
                  selectedFy.slice(0, 4),
                  month.slice(0, 3).toUpperCase(),
                  month.slice(0, 3).toUpperCase(),
                );
          const d = getSectionData(m, s);
          return (
            acc + Number(d[`${selectedRT.toLowerCase()}_to_loaded`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    /////////////////////////////////////////////

    const prevETotalTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b = getDaysBetweenMonths(
            selectedFy.replace(/\d+/g, (y) => +y - 1).slice(0, 4),
            month.slice(0, 3).toUpperCase(),
            month.slice(0, 3).toUpperCase(),
          );
          const d = getSectionData(m, s);
          return (
            acc + Number(d[`${selectedRT.toLowerCase()}_to_empty`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    const currETotalTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b =
            Number(selectedFy.slice(0, 4)) === new Date().getFullYear() &&
            month.slice(0, 3) === mon
              ? date
              : getDaysBetweenMonths(
                  selectedFy.slice(0, 4),
                  month.slice(0, 3).toUpperCase(),
                  month.slice(0, 3).toUpperCase(),
                );
          const d = getSectionData(m, s);
          return (
            acc + Number(d[`${selectedRT.toLowerCase()}_to_empty`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    //////////////////////////////////////////////  ////////////////////////////////////////

    //////////////////////////////////////////////

    ////////////////////////////////

    const option = {
      title: {
        text: `L & E Avg Per Day Comparison – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1,
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: 30,
        data: [
          `T/O L (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `T/O L (${selectedFy})`,
          `T/O E (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `T/O E (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: `T/O L (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevLTotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
            formatter: (p) => Math.round(p.value),
          },
        },
        {
          name: `T/O L (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: currLTotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
            formatter: (p) => Math.round(p.value),
          },
        },
        {
          name: `T/O E (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevETotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `T/O E (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: currETotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
      ],
    };

    myChart.setOption(option);

    // ✅ EASY RESPONSIVE PART
    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      myChart.dispose();
    };
  }, [selectedMonths, selectedSections, sortedPrev, sortedCurr, selectedRT]);

  return (
    <div>
      <div className="papaDiv">
        <div
          id="pwiAvgChart4"
          style={{ width: "100%", height: "50vh", marginTop: "30px" }}
        ></div>
      </div>
    </div>
  );
};

export default AvgMWPWILEGraph;
